/** @jsx jsx */
import { memo } from 'react';
import { token } from '@atlaskit/tokens';
import { cssMap, jsx } from '@atlaskit/css';
import { SimpleTag } from '@atlaskit/tag';
import type { ColoredLabel } from '@atlassian/jira-issue-shared-types/src/common/types/labels-type.tsx';
import { getColorMetadata } from '@atlassian/jira-option-color-picker/src/color-picker/utils/index.tsx';
import { memoizeGetAutoGeneratedColorForLabels } from '@atlassian/jira-option-color-picker/src/option-color-generator/index.tsx';
import { expVal } from '@atlassian/jira-feature-experiments';
import { ColoredTag } from '@atlassian/jira-option-color-picker/src/colored-tag/index.tsx';

type Props = {
	labels: string[] | ColoredLabel[];
};

export const CardLabels = ({ labels }: Props) => {
	return (
		<div css={styles.root}>
			{labels.map((label) => {
				if (
					expVal(
						'adding-color-to-labels-field-experiment-milestone2',
						'isColorfulNewLabelsEnabled',
						false,
					)
				) {
					if (typeof label !== 'string') {
						const { backgroundColor: color } = getColorMetadata(
							label.color || memoizeGetAutoGeneratedColorForLabels(label.name),
						);

						return <ColoredTag key={label.name} labelName={label.name} color={color} />;
					}
					return <SimpleTag key={label} text={label} />;
				}
				// @ts-expect-error - ts2322 - Type 'ColoredLabel' is not assignable to type 'string'.
				return <SimpleTag key={label} text={label} />;
			})}
		</div>
	);
};

export default memo(CardLabels);

const styles = cssMap({
	root: {
		display: 'flex',
		alignItems: 'center',
		flexFlow: 'row wrap',
		marginTop: token('space.negative.050'),
		marginRight: token('space.negative.050'),
		marginBottom: token('space.negative.050'),
		marginLeft: token('space.negative.050'),
		width: '100%',
	},
});
